























import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwModal, SwModalBody } from '@libs-uuif/shared/sw-modal';

@Component({
  components: {
    SwModal,
    SwModalBody,
  },
})

export default class ErrorLogs extends SwExtendedVue {
  @Prop() errorList: any[];
  @Prop() errorLogsModal: boolean;

  closeDialog(value:boolean = false) {
    this.$emit('closeErrorLogDialog', value);
  }

}
